// calc-client.js — anteprima live dei calcoli: riusa la STESSA lib del server
// (server/src/lib/fatt-calc.js, CommonJS puro senza dipendenze node — esbuild
// la bundla via require). UN SOLO motore: il client non reimplementa NULLA.
// L'anteprima è SOLO cosmetica: dopo ogni salvataggio l'editor mostra i numeri
// del SERVER (contratto §UI). Se la firma della lib cambiasse, anteprima()
// degrada a null (l'editor tiene i numeri server) — mai un crash di render.

/* eslint-disable global-require */
const calc = require('../../../server/src/lib/fatt-calc.js');

export const ricalcolaFattura = calc.ricalcolaFattura;

// anteprima(record, cliente) → record ricalcolato oppure null (mai throw).
// Il motore legge opts.splitPayment (fatt-calc.js:127): lo si deriva dal
// cliente scelto; si passa anche il DTO intero per compatibilità futura.
export function anteprima(record, cliente) {
  try {
    if (typeof calc.ricalcolaFattura !== 'function') return null;
    const out = calc.ricalcolaFattura(record, {
      splitPayment: !!(cliente && cliente.splitPayment),
      cliente: cliente || null,
    });
    if (!out || typeof out !== 'object' || !Array.isArray(out.righe)) return null;
    return out;
  } catch (e) {
    return null; // anteprima degradata: fanno fede i numeri del server
  }
}

export default calc;
